import { forwardRef, createElement } from 'react';

function IconPersonChange(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M14.75 11.5c4.166 0 6.596 2.43 7.291 7.29A2.813 2.813 0 0119.257 22h-9.014a2.813 2.813 0 01-2.784-3.21c.695-4.86 3.125-7.29 7.291-7.29zm0 1.5c-3.37 0-5.211 1.84-5.806 6.002a1.313 1.313 0 001.165 1.491l.134.007h9.014a1.313 1.313 0 001.3-1.498C19.96 14.84 18.12 13 14.75 13zM6.446 6.397l.084.073 3 3a.75.75 0 01.073.976l-.073.084-3 3a.75.75 0 01-1.133-.976l.073-.084 1.719-1.72H1.75a.75.75 0 01-.102-1.493l.102-.007h5.439l-1.72-1.72a.75.75 0 01-.072-.976l.073-.084a.75.75 0 01.976-.073zM14.75 2c1.933 0 3.5 1.903 3.5 4.25s-1.567 4.25-3.5 4.25-3.5-1.903-3.5-4.25S12.817 2 14.75 2zm0 1.5c-1.033 0-2 1.174-2 2.75s.967 2.75 2 2.75 2-1.174 2-2.75-.967-2.75-2-2.75z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var PersonChange = /*#__PURE__*/forwardRef(IconPersonChange);

export default PersonChange;
//# sourceMappingURL=PersonChange.js.map
